import Spinner from '@preqin/ui-components/cjs/core/Spinner';

import logo from './preqinLogoExternal.svg';

import style from './AppSpinner.module.scss';

export const AppSpinner = () => (
  <div style={{ padding: '20px' }}>
    <Spinner size="sm" color="neutral" text="" />
  </div>
);

export const PreqinLogo = () => (
  <div id="preqin-report-logo" className={style.preqinReportLogo}>
    <img className={style.logo} src={logo} width="50" height="50" alt="logo" />
    <div>Loading Data...</div>
  </div>
);
